import { Button, TextField, Typography } from "@material-ui/core";
import { createStyles, makeStyles, styled, Theme } from "@material-ui/core/styles";
import * as Cookies from "js-cookie";
import * as React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { openSnackbar } from "../../Actions/ActionFunctions";
import { SnackbarStatus } from "../../Definitions/Definitions";
import * as ThemeConstants from "../../Styles/Constants";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            margin: "auto",
            marginTop: "3rem",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "0.5rem",
            maxWidth: 800
        }
    })
);

export const FeedbackPage = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();

    const [text, setText] = React.useState("");
    const [sending, setSending] = React.useState(false);

    const updateText = (newText: string) => {
        const trimmed = newText.substring(0, 750);
        setText(trimmed);
        localStorage.setItem("feedbackText", trimmed);
    }

    const submit = () => {
        setSending(true);
        const url = "api/submitFeedback";
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'X-XSRF-TOKEN': Cookies.get("XSRF-TOKEN") || ""
            },
            body: JSON.stringify(text),
            credentials: 'same-origin'
        })
            .then(result => {
                if (result.ok) {
                    dispatch(openSnackbar(SnackbarStatus.Success, "Feedback submitted successfully!", 3000));
                    localStorage.setItem("feedbackText", "");
                    history.push("/");
                }
                else
                    dispatch(openSnackbar(SnackbarStatus.Error, "Failed to submit feedback", 3000));
                setSending(false);
            });
    }
    
    React.useEffect(() => {
        const loadedText = localStorage.getItem("feedbackText");
        if (loadedText)
            updateText(loadedText);
    }, [])

    return (
        <div className={classes.root}>
            <Typography variant="h2"><b>Feedback</b></Typography>
            <Typography variant="h6">Got something nice to say? Complaints? Ideas? Bugs? I would love to hear it!</Typography>
            <TextField
                style={{ width: "100%", marginTop: "1rem" }}
                label="Enter text here"
                multiline
                rows={8}
                value={text}
                disabled={sending}
                onChange={(e) => updateText(e.target.value)}
                variant="outlined"
            />
            <Typography variant="h6" color="textSecondary">{text.length}/750 characters</Typography>
            <Button variant="outlined" color="primary" onClick={submit} disabled={sending || text.length == 0}>Submit</Button>
        </div>
    );
}